import { render, staticRenderFns } from "./book-create.vue?vue&type=template&id=d036d9c0&"
import script from "./book-create.vue?vue&type=script&lang=js&"
export * from "./book-create.vue?vue&type=script&lang=js&"
import style0 from "./book-create.vue?vue&type=style&index=0&id=d036d9c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports